<template>
  <div class="list-item"
       :class="itemClasses"
       @click="handleClick">
    <div class="list-item-content">
      <div class="list-item-prefix"/>
      <el-input v-if="item.isEditing"
                ref="editInput"
                v-model="editValue"
                size="mini"
                class="list-item-edit-input"
                @blur="handleEditBlur"
                @keyup.enter.native="handleEditConfirm"
                @keyup.esc.native.stop="handleEditCancel">
        <i slot="suffix"
           class="el-icon-circle-close"
           style="cursor: pointer; line-height: 24px; font-size: 14px;"
           v-show="editValue"
           @mousedown.prevent="handleClearClick"/>
      </el-input>
      <span v-else class="list-item-text" @dblclick.stop="handleDoubleClick">{{ item.groupName }}</span>
    </div>
    <el-popover trigger="click"
                v-if="!item.isEditing && !isDefaultGroup"
                placement="bottom-start"
                popper-class="layout-menu-dialog-sider-popover"
                @show="showPopover"
                @hide="hidePopover">
      <div class="popover-actions">
        <div class="action-item" @click="handleRename">
          <span class="edit">重命名(支持双击编辑)</span>
        </div>
        <div class="action-item del" @click="handleDelete">
          <span class="del">删除</span>
        </div>
      </div>
      <template slot="reference">
        <div class="more-icon" @click.stop />
      </template>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    activeId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      editValue: '',
      originalValue: '', // 保存编辑前的原始值
      isClearing: false // 标记是否正在执行清除操作
    }
  },
  computed: {
    isDefaultGroup() {
      // id 为 1 的是未分组模块，不允许编辑和删除
      return +this.item.id === 1 || this.item.groupName === '未分组模块'
    },
    itemClasses() {
      return {
        'list-item-focus': this.item.focus,
        'list-item-clicked': this.item.id === this.activeId,
        'list-item-draggable': !this.isDefaultGroup && !this.item.isEditing
      }
    }
  },
  watch: {
    'item.isEditing'(val) {
      if (val) {
        this.editValue = this.item.groupName
        this.originalValue = this.item.groupName // 保存原始值
        this.$nextTick(() => {
          this.$refs.editInput && this.$refs.editInput.focus()
        })
      }
    },

  },
  methods: {
    handleClick() {
      this.$emit('click', this.item)
    },
    showPopover () {
      this.item.focus = true
      this.$emit('popover-show', this.item)
    },
    hidePopover () {
      this.item.popoverShow = false
      this.item.focus = false
    },
    togglePopover() {
      this.item.focus = true
      this.$emit('toggle-popover', this.item)
    },
    handleRename() {
      // 关闭 popover
      this.item.popoverShow = false
      this.$set(this.item, 'isEditing', true)
      // this.$emit('rename', this.item)
    },
    handleDelete() {
      this.$emit('delete', this.item)
    },
    handleDoubleClick() {
      // 未分组模块不允许编辑
      if (this.isDefaultGroup) return
      // 阻止事件冒泡，避免触发列表项点击
      this.$set(this.item, 'isEditing', true)
    },
    handleEditBlur() {
      // 如果是清除操作导致的失焦，不处理
      if (this.isClearing) {
        this.isClearing = false
        return
      }
      this.handleEditConfirm()
    },
    handleClearClick() {
      // 清空输入值
      this.editValue = ''
      // 保持焦点在输入框
      this.$nextTick(() => {
        this.$refs.editInput && this.$refs.editInput.focus()
      })
    },

    async handleEditConfirm() {
      const newValue = this.editValue.trim()
      // 如果值为空或与原值相同，取消编辑并还原
      if (!newValue || newValue === this.item.groupName) {
        this.$set(this.item, 'isEditing', false)
        this.editValue = this.originalValue // 还原为原始值
        return
      }
      try {
        const params = {
          userId: this.$store.state.user.id,
          id: this.item.id,
          groupName: newValue
        }
        await this.$http('system.homeModuleGroup.update', params)
        this.$message.success('保存成功')
        // 更新本地数据
        this.item.groupName = newValue
        this.$emit('update-group', { id: this.item.id, groupName: newValue })
        // 触发全局更新事件，通知 common-module-list 刷新
        this.$bus.$emit('GLOABL_HOME_UPDATE_MENU')
      } catch (error) {
        console.error(error)
        // this.$message.error('保存失败')
      } finally {
        this.$set(this.item, 'isEditing', false)
      }
    },
    handleEditCancel() {
      this.$set(this.item, 'isEditing', false)
    }
  }
}
</script>

<style lang="scss" scoped>
// 常量定义
$primary-color: rgba(121, 83, 246, 1);
$hover-bg: rgba(243, 242, 254, 1);
$border-color: rgba(121, 83, 246, 0.1);

.list-item {
  height: 34px;
  display: flex;
  padding: 0 8px;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 8px;
  color: rgba(69, 60, 90, 1);
  font-size: 13px;
  transition: all 0.2s ease;
  // 内容区域
  .list-item-content {
    flex: 1;
    display: flex;
    align-items: center;
    overflow: hidden;
    height: 34px;
    .list-item-prefix {
      width: 14px;
      height: 14px;
      margin-right: 4px;
      flex-shrink: 0;
      background: url("../../../images/file.svg") no-repeat center center / 14px 14px;
    }

    .list-item-text {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
      user-select: none;
      height: 34px;
      line-height: 34px;
      &:hover {
        opacity: 0.8;
      }
    }

    .list-item-edit-input {
      flex: 1;

      /deep/ .el-input__inner {
        height: 24px;
        line-height: 24px;
        padding: 0 4px;
        font-size: 13px;
        border-radius: 4px;
      }
    }
  }

  // 更多操作图标
  /deep/ .more-icon {
    display: none;
    width: 14px;
    height: 14px;
    border-radius: 3px;
    background: url("../../../images/more.svg") no-repeat center center / 12px 12px;
    //transition: all 0.2s ease;
  }

  // 悬停状态
  &:hover {
    background: $hover-bg;
    color: $primary-color;
    .list-item-prefix {
      background-image: url("../../../images/file-active.svg");
    }
    .more-icon {
      display: block;
      &:hover {
        background: url("../../../images/more-hover.svg") no-repeat center center / 12px 12px;
        border: 1px solid $border-color;
      }
    }
  }
  // 选中状态
  &.list-item-clicked {
    background: $hover-bg;
    color: $primary-color;
    .list-item-prefix {
      background-image: url("../../../images/file-active.svg");
    }
  }

  // 焦点状态（popover 打开时）
  &.list-item-focus {
    /deep/ .more-icon {
      display: block;
      background: url("../../../images/more-hover.svg") no-repeat center center / 12px 12px;
      border: 1px solid $border-color;
    }
  }
  &.sortable-chosen{
    background: rgba(255, 255, 255, 1) !important ;
    box-shadow: 0 4px 8px 0 rgba(6, 2, 62, 0.08) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/sider/list-item.vue